
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import PropTypes from 'prop-types';

function SmartTable(props) {
    return Template.default.apply({ props });
}

SmartTable.propTypes = {
    data: PropTypes.array.isRequired,
    className: PropTypes.string,
    columnConfig: PropTypes.array.isRequired,
    rowClick: PropTypes.func,
    headerMissing: PropTypes.bool,
    activeRowOpen: PropTypes.func,
    activeRowContent: PropTypes.func
};

export default SmartTable;